module.exports = __webpack_public_path__ + "img/emoji_54.a793008c.png";